<template>
  <el-popover popper-class="el-popover-activity-clean"
    v-if="(detail && detail.expireDay > 0 && detail.expireStatus != 1)" placement="bottom-start" width="580"
    trigger="hover">
    <div class="flex flex-direction align-center justify-center">
      <div class="text-red text-lg text-600 text-center">活动{{ detail.expireDay }}天后将被移入回收站</div>
      <div class="text-lg margin-top-sm text-center">活动{{ unixtoTime(detail.createTime, 'YYYY/MM/DD')
        }}创建:清理前组织者可从回收站自行恢复</div>
      <div class="flex margin-top">
        <div class=" padding bg-gray radius" style="width: 335px;">
          <pre class="text-df">以账号下有两个活动示例:
当前为2022/12/31
活动二5G，2022/5/15创建，保存期限 90天
活动-15G，2021/10/15创建，保存期限 93 天以下两种情况，均会触发清理活动:
①超出存储空间。例如，账号可用存储空间为10G，已用存储空间为20G，超出10G。按活动创建时间的先后顺序，则活动一移入回收站;
②超过保存期限。则活动一、活动二超过保存期限,移入回收站;
免费保存90 天:会员期间，90天的倒计时停止，会员到期后倒计时继续。</pre>
        </div>
        <img style="width: 148px;height: 297px;" src="https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%207@3x.png" alt=""
          class="margin-left"></img>
      </div>
      <div class="flex margin-top-xl">
        <a :href="buyVipUrl" target="_blank">
          <div class="buy-storage-but">升级会员，延长保存期限</div>
        </a>
        <a :href="buyStorageUrl" target="_blank" class="margin-left-lg">
          <div class="buy-storage-but">购买存储，延长保存期限</div>
        </a>
      </div>

    </div>
    <div slot="reference" class="activity-clean flex align-center justify-center">
      <div class="flex align-center justify-center">
        {{ detail.expireDay }}天后清理
        <div class="activity-clean-icon"></div>
      </div>

    </div>

  </el-popover>
</template>

<script>
import App from '../../util/comfun'
export default {
  components: {

  },
  props: {
    detail: Object,
  },
  data() {
    return {
      buyStorageUrl: '',
      buyVipUrl: '',
    }
  },
  methods: {
    MG: App.MG,
    unixtoTime: App.unixtoTime,
    gotoBuyStorage() {
      this.$router.push({
        path: '/checkout/buyStorage'
      })
    },
    init() {
      let userId = wxlite.getStorageSync('userId')
      this.buyVipUrl = App.getH5({
        version: encodeURIComponent(JSON.stringify({
          from: 'pc',
          token: wxlite.getStorageSync('token'),
          uid: userId
        })),
        "_": '',
      }, '')
      App.demand('/user/vipInfo/current', 'GET').then(res => {
        if (res.data) {
          if (res.data.vipType > 0) {
            this.endTimeStr = App.unixtoTime(res.data.endTime, '有效期至YYYY年MM月DD日')
          }
          this.vipType = res.data.vipType
        }
      })
      App.demand('/user/info', 'GET', {
        userId: userId,
      }).then(res => {
        this.residualDownloadTraffic = res.data.residualDownloadTraffic / 1
      })
    },
    logout() {
      localStorage.removeItem('userinfo');
      this.$router.replace({
        path: '/'
      })
    },
    gotoService() {
      this.$router.replace({
        path: '/pay'
      })
    },
    buyVip() {
      this.$router.push({
        path: '/checkout/buyVip'
      })

    },
    buyTraffic() {
      let userId = wxlite.getStorageSync('userId')
      this.$router.push({
        path: '/checkout/buyTraffic?activityId=0&activityName=0&userId=' + userId
      })
    },
    async getVersion() {
      if (!wxlite.VERSIONS) {
        let vds = (await App.demand('/activity/version/loadConfigList', 'GET')).data;
        let vers = {};
        vds.forEach(ver => {
          vers[ver.versionType] = ver
        });
        wxlite.VERSIONS = vers
      }
      this.VERSIONS = wxlite.VERSIONS
    },

    getH5params(key = '') {
      let params = {};
      params[key] = encodeURIComponent(JSON.stringify({
        userId: wxlite.getStorageSync('userId'),
        //hasInBusiness:wxlite.hasInBusiness?1:0,

        from: 'pc',
        token: wxlite.getStorageSync('token'),
        uid: this.detail.createBy
      }));
      return App.getH5({
        ...params,
        '_': '',
      }, '');
    },
    buyStorage() {
      this.buyStorageUrl = this.getH5params('buy-storage')
      this.buyVipUrl = this.getH5params('version')
    },
  },
  mounted() {
    //this.getVersion()
    this.buyStorage()
  }
}
</script>

<style scoped lang="scss">
.fotoo-el-popover,
.fotoo-el-popover.el-popover {
  padding: 0;
}

.reference {
  cursor: pointer;


}

.activity-clean {
  width: 87px;
  height: 25px;
  background-image: linear-gradient(-88deg, #F5515F 0%, #D87D25 100%);
  border-radius: 5px 0 0 5px;


  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}

.activity-clean-icon {
  width: 9px;
  height: 9px;
  background-size: 100% 100%;
  background-image: url("https://assets.pfotoo.com/images/pc-help/question-circle-o%E5%A4%87%E4%BB%BD%203@2x@3x.png");
  margin-left: 5px;
}

.el-popover-activity-clean.el-popover {}

.buy-storage-but {
  width: 230px;
  height: 40px;
  background: #3DC4A7;
  border-radius: 30px;

  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  margin: 10px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/draft-lastday.vue